import mixitup from 'mixitup';

const getFilterFromUrl = () => {
	const tag = new URLSearchParams( window.location.search ).get( 'tag' );

	return tag ? `.tag-${ tag }` : 'all';
};

const updateFilterUrl = tagSlug => {
	const url = new URL( window.location.href );

	if ( tagSlug ) {
		url.searchParams.set( 'tag', tagSlug );
	} else {
		url.searchParams.delete( 'tag' );
	}

	window.history.replaceState( {}, '', url );
};

const setActiveFilterButton = ( buttons, filter ) => {
	buttons.forEach( button => {
		const isActive = button.dataset.filter === filter;

		button.classList.toggle( '-green', isActive );
		button.classList.toggle( '-link', ! isActive );

		if ( isActive ) {
			button.setAttribute( 'aria-current', 'true' );
		} else {
			button.removeAttribute( 'aria-current' );
		}
	} );
};

const updateEmptyState = ( emptyState, visibleCount ) => {
	if ( ! emptyState ) {
		return;
	}

	const isEmpty = visibleCount === 0;

	emptyState.hidden = ! isEmpty;
	emptyState.classList.toggle( '-is-visible', isEmpty );
};

const getVisibleCountForFilter = ( grid, filter ) => {
	const items = grid.querySelectorAll( '.mix' );

	if ( filter === 'all' ) {
		return items.length;
	}

	return Array.from( items ).filter( item => item.matches( filter ) ).length;
};

const initPostArchiveFilter = () => {
	const grid = document.querySelector( '.js-postArchiveGrid' );

	if ( ! grid ) {
		return;
	}

	const archive = grid.closest( '.js-postArchive' ) || grid.parentElement;
	const filterButtons = Array.from( archive.querySelectorAll( '.js-postArchiveFilter' ) );
	const emptyState = archive.querySelector( '.js-postArchiveEmpty' );
	const initialFilter = grid.dataset.initialFilter || getFilterFromUrl() || 'all';

	const mixer = mixitup( grid, {
		selectors: {
			target: '.mix',
		},
		controls: {
			enable: false,
		},
		animation: {
			animateResizeContainer: true,
			effects: 'fade scale',
			duration: 500,
		},
		load: {
			filter: initialFilter,
		},
		callbacks: {
			onMixEnd( state ) {
				updateEmptyState( emptyState, state.show.length );
			},
		},
	} );

	const applyFilter = ( filter, tagSlug = '' ) => {
		setActiveFilterButton( filterButtons, filter );
		updateFilterUrl( tagSlug );
		updateEmptyState( emptyState, getVisibleCountForFilter( grid, filter ) );
		mixer.filter( filter );
	};

	filterButtons.forEach( button => {
		button.addEventListener( 'click', () => {
			applyFilter( button.dataset.filter || 'all', button.dataset.tagSlug || '' );
		} );
	} );

	window.addEventListener( 'popstate', () => {
		const filter = getFilterFromUrl();
		const activeButton = filterButtons.find( button => button.dataset.filter === filter );

		applyFilter( filter, activeButton?.dataset.tagSlug || '' );
	} );

	setActiveFilterButton( filterButtons, initialFilter );
};

document.addEventListener( 'DOMContentLoaded', initPostArchiveFilter );
